export function getFormatedLastClockInTimeFromDate(minutes: number): string {
   if (typeof minutes !== 'number' || minutes < 0 || minutes > 1440) {
      throw new Error('Input must be a number between 0 and 1440 (inclusive).')
   }

   const hours = Math.floor(minutes / 60)
   const remainingMinutes = minutes % 60

   const formattedHours = String(hours).padStart(2, '0')
   const formattedMinutes = String(remainingMinutes).padStart(2, '0')

   return `${formattedHours}h:${formattedMinutes}m`
}
